// extracted by mini-css-extract-plugin
export default {"activeLink":"breadcrumb_activeLink__n2aww","inActiveLink":"breadcrumb_inActiveLink__yVIyp"};